import React, { useEffect, useState } from "react";

// --- CONFIG ---
const GA_ID = "AW-16523547017"; // <-- replace with your GA4 id

function loadGA() {
  if (window.gtagLoaded) return;

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA_ID, {
    anonymize_ip: true,
  });

  window.gtagLoaded = true;
}


export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");

    if (!consent) {
      setVisible(true);
    } else if (consent === "accepted") {
      loadGA();
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    loadGA();
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookie_consent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="w-full bg-white/85 backdrop-blur-md border-t border-gray-200 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col md:flex-row items-center gap-3">
          <div className="text-sm text-gray-700 flex-1 leading-relaxed">
            We use cookies on our website for your comfortable service, to
            remember your preferences, and to analyze traffic. By clicking
            "Accept", you consent to the use of non-essential cookies.
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={rejectCookies}
              className="text-gray-700 px-3 py-2 text-sm hover:bg-gray-100 transition"
            >
              Disable
            </button>

            <button
              onClick={acceptCookies}
              className="px-4 py-2 text-sm font-medium bg-blue-500 text-white hover:bg-green-700 transition"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ------------------------------
// HOW TO USE
// ------------------------------
// 1. Put <CookieBanner /> once in your App.jsx
// 2. Replace GA_ID with your real GA4 id
// 3. IMPORTANT: remove any GA script from index.html
//    (analytics must load ONLY after consent)

// ------------------------------
// OPTIONAL: manual check example
// ------------------------------
// const consent = localStorage.getItem("cookie_consent");
// if (consent === "accepted") { ... }

/* 
<!-- Google ads -->
<!-- Google tag (gtag.js) -->
<!--     <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16523547017">
</script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-16523547017');
</script> -->

<!-- Event snippet for conversion page -->
<!--     <script>
  gtag('event', 'conversion', {
      'send_to': 'AW-16523547017/TzlkCMq5pKQZEImjhcc9',
      'value': 1.0,
      'currency': 'USD'
  });
  </script> -->

<!-- **** Google analytics ***** -->
<!-- Google tag (gtag.js) -->
<!--     <script async src="https://www.googletagmanager.com/gtag/js?id=G-YGGNLQ1M5H"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-YGGNLQ1M5H');
</script> -->
<!-- **** Start Alex Test 2025-04-23 ***** -->
<!-- Google tag (gtag.js) -->
<!--     <script async src="https://www.googletagmanager.com/gtag/js?id=G-L1HN4P691F"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-L1HN4P691F');
</script> -->
<!-- **** END Alex Test 2025-04-23 ***** --> 

*/